var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGuard = function SvgGuard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 25 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.028 6.534a1.33 1.33 0 0 0-.73-1.06L12.63.141a1.33 1.33 0 0 0-1.193 0L.77 5.474a1.34 1.34 0 0 0-.729 1.06C.026 6.677-1.24 20.89 11.493 26.553a1.32 1.32 0 0 0 1.083 0C25.309 20.89 24.042 6.678 24.028 6.534m-11.994 17.33v-10.53H3.381a20.6 20.6 0 0 1-.725-5.82l9.378-4.689v10.51h8.614c-1.012 3.653-3.33 7.971-8.614 10.529"
  })));
};
export default SvgGuard;